module.exports = __webpack_public_path__ + "static/media/kayo.a2679a5c.webp";